module.exports = __webpack_public_path__ + "static/self-d874f80b32963dd36b9bebb68d116519.jpg";